// test1726
(1726 && 0);
